import React, { FC } from 'react';
import { Button, Modal } from '@marriott/mi-ui-library';

import { ResendQGConfirmationEmailProps } from './ResendQGConfirmationEmail.types';
import { StyledResendQGConfirmationEmail } from './ResendQGConfirmationEmail.styles';

export const ResendQGConfirmationEmail: FC<ResendQGConfirmationEmailProps> = ({ labels, show, onClose }) => {
  return (
    <StyledResendQGConfirmationEmail
      data-testid="groups-ResendQGConfirmationEmail"
      data-component-name="o-groups-ResendQGConfirmationEmail"
    >
      <Modal
        modalId="resendQGConfirmationEmailModal"
        role="dialog"
        labelledBy="resendQGConfirmationEmailModal"
        secondaryClassName="resend-in-modal"
        show={show}
        popupOpenState={show}
        handleBlur={true}
        disableScrollOnBody={true}
        setPopupOpenState={onClose}
        onClose={onClose}
      >
        <Modal.Header labelText={labels.heading} popupHeaderOnCLoseFunc={onClose} className="modal-header" />
        <Modal.Body className="modal-body">
          <div className="p-2">
            <p className="t-subtitle-l">{labels.body}</p>
            <div className="cta-container px-2">
              <Button className="m-buttom-l m-button-primary button" ariaLabel={labels.sendCTA} callback={onClose}>
                {labels.sendCTA}
              </Button>
              <Button className="m-buttom-l m-button-secondary button" ariaLabel={labels.cancelCTA} callback={onClose}>
                {labels.cancelCTA}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </StyledResendQGConfirmationEmail>
  );
};
